enum AccountDetailsPaymentMethod {
  DIRECT_DEBIT = 'DIRECT_DEBIT',
  GIRO = 'GIRO',
}

export default AccountDetailsPaymentMethod;
